import { apiRequest } from '@/api/http';
import { PlatformStatus } from '@/api/schemas/platform-status';

/**
 * ko-backend#939 — `GET /admin/platform/status`. ADMIN and, since
 * ko-backend#980, STAFF: a staff member gets `null` for every card whose list
 * they cannot open. A backend older than that answers a STAFF member 403.
 */
export function getPlatformStatus(): Promise<PlatformStatus> {
  return apiRequest('/admin/platform/status', { schema: PlatformStatus });
}
